import React from "react";
import { Router, useRouter } from "./Router";
import { AuthGuard } from "./AuthGuard";
import { SetupPage } from "../pages/SetupPage";
import { LoginPage } from "../pages/LoginPage";
import { CalendarPage } from "../pages/CalendarPage";
import { SettingsPage } from "../pages/SettingsPage";

function Routes() {
  const { path } = useRouter();

  switch (path) {
    case "/setup":
      return <SetupPage />;
    case "/login":
      return <LoginPage />;
    case "/settings":
      return <SettingsPage />;
    default:
      return <CalendarPage />;
  }
}

export function App() {
  return (
    <Router>
      <AuthGuard>
        <Routes />
      </AuthGuard>
    </Router>
  );
}
